export default {
    audioList: null,
    curOid: 0, // 当前播放 oid
    playState: {
        oid: 0,
        time: 0,
        duration: 0,
        playing: false
    }
}
